module.exports = __webpack_public_path__ + "img/vaibhav_sir_thumbnail1.58a0cd57.jpg";